import { render } from "./PrintIcon.vue?vue&type=template&id=7a72623a&ts=true"
import script from "./PrintIcon.vue?vue&type=script&lang=ts"
export * from "./PrintIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__